import type * as THREE from 'three';
import type { GpuClock } from './GpuClock';

/**
 * Developer overlay (?stats): frame and CPU time percentiles, GPU time (from the shared GpuClock),
 * draw calls and the adaptive controller's state.
 */
export class Perf {
  private el: HTMLDivElement;
  private frames: number[] = [];
  private cpu: number[] = [];
  private t0 = 0;
  private acc = 0;

  constructor(private readonly renderer: THREE.WebGLRenderer, private readonly clock: GpuClock, private readonly dpr: () => string) {
    // count every pass of the frame (composer renders several), not just the last one
    renderer.info.autoReset = false;
    this.el = document.createElement('div');
    Object.assign(this.el.style, { position: 'fixed', left: '8px', top: '8px', padding: '6px 8px', font: '11px/1.35 ui-monospace,monospace', color: '#cfe', background: 'rgba(0,0,0,.55)', pointerEvents: 'none', whiteSpace: 'pre', zIndex: '10', borderRadius: '4px' });
    document.body.appendChild(this.el);
  }

  begin(frameDt: number) {
    this.frames.push(frameDt * 1000);
    this.t0 = performance.now();
    this.renderer.info.reset();
  }

  end(dt: number) {
    this.cpu.push(performance.now() - this.t0);
    if ((this.acc += dt) < 0.5) return;
    this.acc = 0;
    const pct = (a: number[], p: number) => { if (!a.length) return 0; const s = [...a].sort((x, y) => x - y); return s[Math.min(s.length - 1, Math.floor(s.length * p))]; };
    const f50 = pct(this.frames, 0.5), f95 = pct(this.frames, 0.95);
    const info = this.renderer.info.render, gpu = this.clock.drain();
    this.el.textContent =
      `fps   ${(1000 / f50).toFixed(0)}  (p95 ${f95.toFixed(1)} ms)\n` +
      `cpu   ${pct(this.cpu, 0.5).toFixed(2)} ms  p95 ${pct(this.cpu, 0.95).toFixed(2)}\n` +
      `gpu   ${this.clock.available ? pct(gpu, 0.5).toFixed(2) + ' ms  p95 ' + pct(gpu, 0.95).toFixed(2) : 'n/a'}\n` +
      `draw  ${info.calls}  tris ${(info.triangles / 1000).toFixed(0)}k\n` +
      `dpr   ${this.dpr()}`;
    this.frames.length = this.cpu.length = 0;
  }
}
